import { $ } from '@/libs/jquery/index'

export class AuthToastHelper {
  constructor() {
    this.init()
  }

  public init(): void {
    this.hideStartupToast()
  }

  // удаление флэш-сообщений, когда они появляются
  private hideStartupToast(): void {
    setTimeout(() => {
      $('.toast').remove()
    }, 6000)
  }
}
